import React, { useState } from 'react';
import './StarlinkFAQ.scss';

const StarlinkFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "How is Starlink different from Shadow Tracker?",
      answer: "Starlink is designed for daily-use fleet vehicles with hardwired installation, professional fleet management features, and driver behavior monitoring. Shadow is for occasional-use vehicles with battery power and stealth design. Different tools for different needs."
    },
    {
      question: "What's included in the installation?",
      answer: "Professional installation includes hardwiring into your vehicle's electrical system, concealed placement, testing, and driver training. Takes about 1 hour per vehicle. Our certified technicians ensure tamper-proof installation."
    },
    {
      question: "How many vehicles can I manage?",
      answer: "Starlink scales from 1 to 300+ vehicles. The 365 Trac platform provides centralized fleet management with unlimited users, custom roles, and multi-location support. Perfect for growing businesses."
    },
    {
      question: "What fleet management features are included?",
      answer: "Real-time GPS tracking, driver behavior monitoring (speeding, harsh braking), route optimization, geofencing, fuel efficiency tracking, maintenance alerts, detailed trip reports, and 24/7 live monitoring."
    },
    {
      question: "Is there a monthly fee?",
      answer: "Yes, Starlink requires a monthly subscription that includes cellular connectivity, 365 Trac platform access, cloud storage, and support. Pricing varies by fleet size - contact us for a custom quote."
    },
    {
      question: "Can drivers tamper with the device?",
      answer: "No. Starlink is hardwired into the vehicle's electrical system in a concealed location. Attempting to remove or disable it triggers immediate alerts. This is a key advantage over battery-powered trackers."
    },
    {
      question: "What's the dual protection system?",
      answer: "Starlink includes a visible primary tracker for fleet management AND a hidden backup tracker (Shadow) that activates if the primary is compromised. Two-layer protection for maximum security."
    },
    {
      question: "Do you offer enterprise support?",
      answer: "Yes! Enterprise customers get dedicated account managers, priority support, custom integrations, API access, and on-site training. We support fleets of all sizes with 24/7 technical assistance."
    }
  ];

  return (
    <section className="starlink-faq">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <p className="subtitle">Everything you need to know about Starlink Fleet Management</p>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StarlinkFAQ;
